import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'bootstrap-app',
  templateUrl: './bootstrap-app.component.html',
  styleUrls: ['./bootstrap-app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
  encapsulation: ViewEncapsulation.None
})
export class BootstrapAppComponent {}
